import {
  Chip,
  FormControl,
  Input,
  InputLabel,
  List,
  ListItem,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MDButton from "components/MDButton";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { KeyValue } from "common/models";
import AddIcon from "@mui/icons-material/Add";

const ChipInput = (props) => {
  const [items, setItems] = useState<KeyValue[]>(props.items);
  const [value, setValue] = useState<string | null>(null);
  const [showAdd, setShowAdd] = useState<boolean>(false);

  useEffect(() => {
    setItems(props.items);
  }, [props.items]);

  const addItem = () => {
    props.addItem(value);
    setShowAdd(false);
    setValue(null);
  };

  const deleteItem = (value: string) => {
    props.deleteItem(value);
  };

  return (
    <>
      <Grid item xs={12}>
        <MDBox p={1} sx={{ display: "flex", flexDirection: "row" }}>
          <Typography variant="body2">{props.label}</Typography>
          <AddIcon onClick={(e) => setShowAdd(!showAdd)} />
          <MDBox sx={{ display: showAdd ? "block" : "none" }}>
            <FormControl sx={{ ml: 2 }}>
              <TextField
                name="chip-input"
                label={props.label}
                value={value || ""}
                onChange={(e) => setValue(e.target.value)}
                inputProps={{ maxLength: props.maxWidth ?? 500 }}
              />
            </FormControl>
            <MDButton sx={{ ml: 1 }} variant="contained" color="secondary" onClick={addItem}>
              <AddIcon />
            </MDButton>
          </MDBox>
        </MDBox>
        <MDBox pb={1} px={1}>
          <Grid container spacing="2">
            <Grid item xs={12} md={8}>
              <List sx={{ display: "flex", flexDirection: "row" }}>
                {items && items.length > 0 ? (
                  items.map((r, i) => {
                    return <Chip key={i} sx={{ mr: 2 }} label={r.name} onDelete={() => deleteItem(r.name!)} />;
                  })
                ) : (
                  <ListItem>No items</ListItem>
                )}
              </List>
            </Grid>
            <Grid item sx={{ mt: 2 }} xs={12} md={8}></Grid>
          </Grid>
        </MDBox>
      </Grid>
    </>
  );
};

export default ChipInput;
